<template>
    <div class="home">
        <el-carousel :interval="5000" :height="Height + 'px'" :class="{ Mobile: isMobile }">
            <el-carousel-item>
                <img src="@/assets/img2/home/img0.png" v-if="$i18n.locale=='zh-CN'" class="bar_img">
                <img src="@/assets/img2/home/en/img0.png" v-else class="bar_img">
            </el-carousel-item>
        </el-carousel>
        <div class="content">
            <div class="row1 flex_r flex_ac">
                <div class="piece flex_r flex_ac flex_jc">
                    <img src="@/assets/img2/home/img1.png">
                </div>
                <div class="piece flex_c flex_as flex_jc">
                    <div class="p1">{{$t('home.frameSlogan')}}</div>
                    <div class="p">{{$t('home.frameDesc')}}</div>
                    <div class="p">{{$t('home.frameTitle')}}</div>
                    <div class="bnt" @click="toProduct">{{$t('index.learnMore')}}<span class="icof">&#xe601;</span></div>
                </div>
            </div>

            <template v-if="$i18n.locale=='zh-CN'">
                <img src="@/assets/img2/product/img4.png" class="row2">
                <img src="@/assets/img2/product/img5.png" class="row3">
                <img src="@/assets/img2/product/img7.png" class="row4">
                <img src="@/assets/img2/product/img8.png" class="row5">
            </template>
            <template v-else>
                <img src="@/assets/img2/product/en/img4.png" class="row2">
                <img src="@/assets/img2/product/en/img5.png" class="row3">
                <img src="@/assets/img2/product/en/img7.png" class="row4">
                <img src="@/assets/img2/product/en/img8.png" class="row5">
            </template>

            <!-- 联系我们 -->
            <div class="row6 flex_r flex_ac flex_jb">
                <div class="col_l">
                    <div class="p1">{{$t('home.keepUpdated')}}</div>
                    <div class="p">{{$t('home.contactEmailDesc')}}</div>
                    <div class="phone flex_r flex_ac">
                        <img src="@/assets/img/foot/phone.png" class="ico">
                        <span>{{$t('home.phone')}}：400-880-3690</span>
                    </div>
                </div>
                <div class="col_r" id="email">
                    <div class="p">{{$t('home.timeCubeWelcome')}}</div>
                    <div class="inpt flex_r flex_ac">
                        <input :placeholder="$t('home.enterEmail')" v-model="email" />
                        <div class="inp_btn" @click="tosub">{{$t('home.subscribe')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <foot-bar />
    </div>
</template>
<script>
let that;
import footBar from "@/components/footbar.vue"
import { EventBus } from '@/utils/eventBus';
import axios from 'axios';
export default {
    name: "home",
    components: {
        footBar,
    },
    data() {
        return {
            Height: 812,
            isMobile: false,
            email: undefined
        };
    },
    created() {
        that = this
        this.autoHeight()
        window.addEventListener('resize', () => {
            that.autoHeight()
        });
    },
    mounted() {
        EventBus.$on('toEmail', this.toEmail);
    },
    methods: {
        autoHeight() {
            this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;
            if (this.isMobile) this.Height = 670
            else this.Height = document.documentElement.clientHeight;
        },
        toProduct() {
            EventBus.$emit('changeTab', "product");
            this.$router.push('product', () => { }, () => { })
        },
        toEmail() {
            const element = document.getElementById('email');
            if (element) {
                window.scrollTo({
                    top: element.offsetTop,
                    behavior: 'smooth' // 平滑滚动
                });
            }
        },
        isValidEmail(email) {
            // 简单的邮箱正则表达式
            const re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        tosub() {
            // 校验邮箱地址
            if (!this.isValidEmail(this.email)) {
                this.$message({
                    message: this.$t('home.validEmail'),
                    type: 'warning'
                });
                this.errorMessage = this.$t('home.validEmail');
                return;
            }

            axios.get(`https://admin.luckysmartech.com/prod-api/admin/message/subscribe?email=${this.email}`)
                .then(response => {
                    this.$message({
                        message: this.$t('home.subscribeSuccess'),
                        type: 'success'
                    });
                })
                .catch(error => {
                    console.error('There was an error fetching the users!', error);
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.FirstImage{
    width: 100%;
    height: 100%;
    background-image: url("@/assets/img2/home/bg1.png");
    background-size: 100% 100%;
    position: relative;
    .Slogan{
        position: absolute;
        left: 20%; top: 50%;
        font-size: 20px;
        .tit{
            font-size: 64px;
            font-weight: 600;
            line-height: 96px;
            margin-bottom: 20px;
        }
    }
}
.Mobile {
    width: 1200px;
}
.bar_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.p1 {
    font-size: 30px;
    font-weight: 600;
}

.p {
    font-size: 16px;
    line-height: 24px;
}

.bnt {
    margin-top: 36px;
    font-size: 14px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    padding: 0 14px;
    border: 1px solid #555;
    border-radius: 4px;
    cursor: pointer;

    .icof {
        color: #555;
        margin-left: 10px;
    }
}

.row1 {
    height: 628px;

    .piece {
        width: 50%;

        &:last-child {
            padding-left: 106px;
        }
    }

    .p1 {
        margin-bottom: 18px;
    }

    img {
        width: 619px;
        height: 466px;
    }
}

.row2 {
    width: 100%;
}

.row3,.row4,.row5 {
    width: 100%;
    margin-top: 120px;
}

.row6 {
    // padding: 0 52px;
    height: 360px;

    .p1{
        margin-bottom: 22px;
    }

    .p {
        padding-right: 100px;
    }

    .phone{
        margin-top: 20px;
        img{
            width: 18px;
            height: 18px;
            margin-right: 10px;
        }
    }

    .inpt {
        width: 430px;
        height: 46px;
        line-height: 46px;
        border: 1px solid #000;
        margin-top: 22px;
        border-radius: 4px;
        overflow: hidden;

        input {
            width: calc(100% - 113px);
            padding: 0 15px;
            height: 100%;
        }

        .inp_btn {
            width: 113px;
            height: 100%;
            text-align: center;
            color: #fff;
            background-color: #333;
        }
    }
}
</style>